import type { InvoiceTrips } from '@bambi/api-client/schemas';
import { DateTime } from 'luxon';

export function formatInvoiceDate(date: string): string {
  return `${DateTime.fromISO(date).toLocaleString(
    DateTime.DATE_MED
  )} at ${DateTime.fromISO(date).toLocaleString(DateTime.TIME_SIMPLE)}`;
}

export function formatInvoicePDFDate(date: string): string {
  return `${DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT)}`;
}

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
}).format;

export function shouldDisplayTripSummaryPrice(
  summary: InvoiceTrips['price_summary'] | null,
  trip: InvoiceTrips
) {
  const dynamicTripPrice = summary?.total ?? 0;
  const tripPrice = trip.input_price_cents;
  const arePricesSame = dynamicTripPrice === tripPrice;

  // If prices are the same we can display the price summary
  return arePricesSame;
}
